import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AppContext from '../../AppContext';
import { getReturnUrl, hasParameters, isValidReturnUrl } from '../../util/urlParser';
import { Button, ButtonType } from '@riotgames/accounts-react-components';
import { WEB_BODY2_CLASS } from '@riotgames/accounts-react-components/lib/Typography';

const handleFinish = (username, urlParams) => {
  const returnUrl = getReturnUrl(username, urlParams);
  window.location.href = returnUrl;
};

const ButtonLogin = () => {
  const context = useContext(AppContext);
  const {
    state: { username, urlParams }
  } = context;

  const hasRsoParams = hasParameters(urlParams);
  const isValidParams = isValidReturnUrl(urlParams);

  if (!hasRsoParams || !isValidParams) {
    return <p className={cx(WEB_BODY2_CLASS, 'button-text-anchor')}>이 창은 닫으셔도 됩니다.</p>;
  }

  return (
    <Button
      className="mobile-button-fullwidth"
      buttonType={ButtonType.primary}
      label={'로그인하기'}
      onClick={() => handleFinish(username, urlParams)}
    />
  );
};

export default ButtonLogin;
